export default __webpack_public_path__ + "static/media/childDevelopment-blob2.af751eaf.svg";